export interface PortfolioSettings {
  // Portfolio categories and their visibility
  categories: {
    bridal: boolean;
    fashion: boolean;
    headshots: boolean;
    seniors: boolean;
    creative: boolean;
    modeling: boolean;
    weddings: boolean;
    graduation: boolean;
    maternity: boolean;
  };
  
  // Menu structure control
  menu: {
    showPortfolio: boolean;
    showPricing: boolean;
    showContact: boolean;
    showClients: boolean;
  };
  
  // Homepage settings
  homepage: {
    showAllCategories: boolean; // If false, only show enabled categories
    maxImagesPerCategory: number; // Limit images per category on homepage
    scrollSpeed: number; // Animation duration in seconds (higher = slower)
  };
}

class SettingsService {
  private settings: PortfolioSettings = {
    categories: {
      bridal: true,
      fashion: true,
      headshots: true,
      seniors: true,
      creative: true,
      modeling: true,
      weddings: false,     // Disabled by default
      graduation: false,   // Disabled by default  
      maternity: false     // Disabled by default
    },
    menu: {
      showPortfolio: true,
      showPricing: false,  // Currently commented out in nav
      showContact: true,
      showClients: true
    },
    homepage: {
      showAllCategories: false, // Only show enabled categories
      maxImagesPerCategory: 3,   // Limit homepage images
      scrollSpeed: 120           // Current scroll speed (120 seconds per cycle)
    }
  };

  getSettings(): PortfolioSettings {
    return this.settings;
  }

  isCategoryEnabled(category: string): boolean {
    return this.settings.categories[category as keyof typeof this.settings.categories] || false;
  }

  getEnabledCategories(): string[] {
    return Object.entries(this.settings.categories)
      .filter(([_, enabled]) => enabled)
      .map(([category, _]) => category);
  }

  isMenuItemEnabled(item: keyof PortfolioSettings['menu']): boolean {
    return this.settings.menu[item];
  }

  // Method to update settings (for future admin interface)
  updateSettings(newSettings: Partial<PortfolioSettings>): void {
    this.settings = { ...this.settings, ...newSettings };
  }
}

export const settingsService = new SettingsService();
